module.exports = __webpack_public_path__ + "img/Group_26847.9563ac86.svg";